var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "user_detail"
  }, [_c('h3', [_vm._v($t("cqal7r4", "成员详情"))]), _c('div', {
    staticClass: "action"
  }, [_c('Button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v($t("oxvu2", "返回"))]), _vm.isAdmin ? _c('span', [_c('Button', {
    staticClass: "buttom",
    on: {
      "click": _vm.edit
    }
  }, [_vm._v($t("mekb2", "编辑"))]), _vm.showDisableOn ? _c('Button', {
    staticClass: "buttom",
    on: {
      "click": _vm.onOpen
    }
  }, [_vm._v($t("eymx2", "启用"))]) : _vm._e(), _vm.showDisableOff ? _c('Poptip', {
    staticClass: "button Poptip-confirm",
    attrs: {
      "confirm": "",
      "title": (_vm.$store && _vm.$store.state && _vm.$store.state.site && _vm.$store.state.site.language || _vm.$i18n && _vm.$i18n.locale, $t("pm9c8js", "\u7981\u7528\u540E\uFF0C${data.userName}\u5C06\u65E0\u6CD5\u767B\u5F55\u4F01\u4E1A\u3002", {
        "data.userName": _vm.data.userName
      })),
      "placement": "bottom"
    },
    on: {
      "on-ok": _vm.onOff
    }
  }, [_c('Button', {
    staticClass: "buttom"
  }, [_vm._v($t("lb5z2", "禁用"))])], 1) : _vm._e(), _c('Poptip', {
    staticClass: "button Poptip-confirm",
    attrs: {
      "confirm": "",
      "title": _vm.language != 'en-US' ? (_vm.$store && _vm.$store.state && _vm.$store.state.site && _vm.$store.state.site.language || _vm.$i18n && _vm.$i18n.locale, $t("elni6ey", "\u5220\u9664\u540E\uFF0C${data.userName}\u7684\u4F01\u4E1A\u4FE1\u606F\u8BB0\u5F55\u5C06\u5B8C\u5168\u88AB\u6E05\u9664\u3002", {
        "data.userName": _vm.data.userName
      })) : $t("4g2t3qe", "的企业信息记录将完全被清除。"),
      "placement": "bottom"
    },
    on: {
      "on-ok": _vm.deleteUser
    }
  }, [_c('Button', {
    staticClass: "buttom"
  }, [_vm._v($t("eslg2", "删除"))])], 1), _vm.showDeparture ? _c('Poptip', {
    staticClass: "button Poptip-confirm",
    attrs: {
      "confirm": "",
      "title": $t("e9su8u5", "确定离职？"),
      "placement": "bottom"
    },
    on: {
      "on-ok": _vm.onDeparture
    }
  }, [_c('Button', {
    staticClass: "buttom"
  }, [_vm._v($t("ler52", "离职"))])], 1) : _vm._e()], 1) : _vm._e()], 1), _c('Row', {
    staticClass: "u_row"
  }, [_c('Col', {
    staticClass: "username",
    attrs: {
      "span": "24"
    }
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.data.userName || $t("dd1tam4", "暂无设置")))]), _vm.showAddSms ? _c('Button', {
    staticClass: "buttom_color",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": _vm.addSms
    }
  }, [_vm._v($t("pchj2", "邀请"))]) : _vm._e(), _vm.showOff ? _c('span', {
    staticClass: "disable"
  }, [_vm._v($t("ecojd3", "已禁用"))]) : _vm._e()], 1)], 1), _c('Row', {
    staticClass: "u_row"
  }, [_c('Col', {
    staticClass: "u_col",
    attrs: {
      "span": "4"
    }
  }, [_vm._v($t("i1y32", "昵称"))]), _c('Col', {
    attrs: {
      "span": "20"
    }
  }, [_vm._v(_vm._s(_vm.data.userNickname || $t("dd1tam4", "暂无设置")))])], 1), _c('Row', {
    staticClass: "u_row"
  }, [_c('Col', {
    staticClass: "u_col",
    attrs: {
      "span": "4"
    }
  }, [_vm._v($t("gfjm2", "工号"))]), _c('Col', {
    attrs: {
      "span": "20"
    }
  }, [_vm._v(_vm._s(_vm.data.userNumber || $t("dd1tam4", "暂无设置")))])], 1), _c('Row', {
    staticClass: "u_row"
  }, [_c('Col', {
    staticClass: "u_col",
    attrs: {
      "span": "4"
    }
  }, [_vm._v($t("k1e32", "状态"))]), _c('Col', {
    attrs: {
      "span": "20"
    }
  }, [_vm._v(_vm._s(_vm.dataStatus))])], 1), _c('Row', {
    staticClass: "u_row"
  }, [_c('Col', {
    staticClass: "u_col",
    attrs: {
      "span": "4"
    }
  }, [_vm._v($t("haa72", "手机"))]), _c('Col', {
    attrs: {
      "span": "20"
    }
  }, [_c('ShowEncInput', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "updateKey": _vm.item.unitId,
      "disabled": true,
      "encText": _vm.data.mobile,
      "params": {
        unitId: _vm.item.unitId,
        userId: _vm.item.userId
      },
      "mode": "UNIT_USER_MOBILE"
    }
  })], 1)], 1), _c('Row', {
    staticClass: "u_row"
  }, [_c('Col', {
    staticClass: "u_col",
    attrs: {
      "span": "4"
    }
  }, [_vm._v($t("pgxs2", "部门"))]), _c('Col', {
    attrs: {
      "span": "20"
    }
  }, _vm._l(_vm.data.organizations, function (item) {
    return _c('div', {
      key: item.orgId
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 0)], 1), _c('Row', {
    staticClass: "u_row"
  }, [_c('Col', {
    staticClass: "u_col",
    attrs: {
      "span": "4"
    }
  }, [_vm._v($t("padf2", "邮箱"))]), _c('Col', {
    attrs: {
      "span": "20"
    }
  }, [_c('ShowEncInput', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "updateKey": _vm.item.unitId,
      "encText": _vm.data.userEmail,
      "disabled": true,
      "params": {
        unitId: _vm.item.unitId,
        userId: _vm.item.userId
      },
      "mode": "UNIT_USER_EMAIL"
    }
  })], 1)], 1), _c('Row', {
    staticClass: "u_row"
  }, [_c('Col', {
    staticClass: "u_col",
    attrs: {
      "span": "4"
    }
  }, [_vm._v($t("op822", "身份"))]), _c('Col', {
    attrs: {
      "span": "20"
    }
  }, [_vm._v(_vm._s(_vm.isAdminNameFn(_vm.data.isAdmin) || $t("dd1tam4", "暂无设置")))])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };